import React, { useState, useEffect, useCallback } from 'react';
import { Input, Icon } from 'semantic-ui-react';
import _ from 'lodash';

const SearchInput = ({ data, searchType, handleResults }) => {
  const [filterValue, setFilterValue] = useState('');

  // 🔍 Deep search: match KEY or VALUE, return both
  const deepSearch = (obj, search) => {
    if (obj == null) return null;

    const term = search.toLowerCase();

    // Primitive value
    if (typeof obj !== 'object') {
      return String(obj).toLowerCase().includes(term) ? obj : null;
    }

    const result = Array.isArray(obj) ? [] : {};

    Object.entries(obj).forEach(([key, value]) => {
      const keyMatches = String(key).toLowerCase().includes(term);

      // If key matches, keep entire value
      if (keyMatches) {
        result[key] = value;
        return;
      }

      // Otherwise search value
      const child = deepSearch(value, term);
      if (child !== null && (typeof child !== 'object' || Object.keys(child).length)) {
        result[key] = child;
      }
    });

    return Object.keys(result).length ? result : null;
  };

  // ⏳ Debounced filter
  const filterData = useCallback(
    _.debounce((value) => {
      if (!value) {
        handleResults({ searchType, results: data });
        return;
      }

      const results = deepSearch(data, value) || {};
      handleResults({ searchType, results });
    }, 300),
    [data, handleResults, searchType]
  );

  // ▶ Call filterData when input changes
  // useEffect(() => {
  //   filterData(filterValue);
  //   return filterData.cancel;
  // }, [filterValue, filterData]);

  return (
    <Input
      fluid
      placeholder="Search..."
      value={filterValue}
      onChange={(e) => setFilterValue(e.target.value)}
      icon={
        filterValue ? (
          <Icon
            name="delete"
            link
            onClick={() => setFilterValue('')}
          />
        ) : (
          <Icon name="search" />
        )
      }
      style={{ marginBottom: 16 }}
    />
  );
};

export default SearchInput;

// import React, { useState, useCallback, useEffect } from 'react'
// import { Icon, Input } from 'semantic-ui-react';

// const SearchInput = ({ data, searchType, handleResults, useDeepSearch }) => {

//   const [filterValue, setFilterValue] = useState();
//   const [hasSearched, setHasSearched] = useState();

//   const filterData = useCallback(
//     _.debounce((value) => {
//       if (!value) {
//         handleResults({ searchType, results: {} });
//         return;
//       }

//       const lowercasedFilter = value.toLowerCase();

//       // Recursive deep search
//       const deepMatch = (obj) => {
//         if (_.isNil(obj)) return false;

//         if (_.isObject(obj)) {
//           return _.some(obj, (val, key) => {
//             const keyMatches = _.toString(key).toLowerCase().includes(lowercasedFilter);
//             return keyMatches || deepMatch(val); // recurse
//           });
//         }

//         return _.toString(obj).toLowerCase().includes(lowercasedFilter);
//       };

//       const results = _.mapValues(data, (category, parentKey) => {
//         const parentKeyMatches = _.toString(parentKey)
//           .toLowerCase()
//           .includes(lowercasedFilter);

//         if (parentKeyMatches) {
//           return category; // keep whole category if parent matches
//         }

//         if (useDeepSearch) {
//           // include whole category if ANY match inside it
//           return deepMatch(category) ? category : {};
//         } else {
//           // shallow filter (your original version)
//           return _.pickBy(category, (item, key) => {
//             const keyMatches = _.toString(key).toLowerCase().includes(lowercasedFilter);
//             const valueMatches = _.some(item, (val) =>
//               _.toString(val).toLowerCase().includes(lowercasedFilter)
//             );
//             return keyMatches || valueMatches;
//           });
//         }
//       });

//       const filteredResults = _.pickBy(results, (category) => !_.isEmpty(category));
//       setHasSearched(true)
//       handleResults({ searchType, results: filteredResults });
//     }, 300),
//     [data]
//   );

//   // Effect to trigger debounced search
//   useEffect(() => {
//     if (filterValue) {
//       filterData(filterValue);
//     } else {
//       if (hasSearched) {
//         handleResults({ searchType, results: data }); // Return the entire dataset if no filter is applied
//       }
//     }
//     return filterData.cancel; // Cancel debounce on cleanup
//   }, [filterValue, filterData, data]);

//   const searchInput = () => <Input
//     icon={
//       filterValue ? (
//         <Icon
//           name="delete"
//           link
//           color='grey'
//           bordered
//           inverted
//           onClick={() => setFilterValue('')} // Clear filterValue on click
//         />
//       ) : (
//         <Icon name="search" color='grey' bordered inverted />
//       )
//     }
//     placeholder="Search..."
//     value={filterValue}
//     onChange={(e) => setFilterValue(e.target.value)}
//     fluid
//     style={{ marginBottom: "16px" }}
//   />

//   return searchInput()

// }

// export default SearchInput
